export default [
  'M68AP',
  'iPhone1,1',
  'A1203',
  'N82AP',
  'iPhone1,2',
  'A1241',
  'A1324',
  'N88AP',
  'iPhone2,1',
  'A1303',
  'A1325',
  'N90AP',
  'iPhone3,1',
  'A1332',
  'N90BAP',
  'iPhone3,2',
  'A1332',
  'N92AP',
  'iPhone3,3',
  'A1349',
  'N94AP',
  'iPhone4,1',
  'A1431',
  'A1387',
  'N41AP',
  'iPhone5,1',
  'A1428',
  'N42AP',
  'iPhone5,2',
  'A1429',
  'A1442',
  'N51AP',
  'iPhone6,1',
  'A1453',
  'A1533',
  'N53AP',
  'iPhone6,2',
  'A1457',
  'A1518',
  'A1528',
  'A1530',
  'N48AP',
  'iPhone5,3',
  'A1456',
  'A1532',
  'N49AP',
  'iPhone5,4',
  'A1507',
  'A1516',
  'A1526',
  'A1529',
  'N61AP',
  'iPhone7,2',
  'A1549',
  'A1586',
  'A1589',
  'N56AP',
  'iPhone7,1',
  'A1522',
  'A1524',
  'A1593',
  'N71AP',
  'iPhone8,1',
  'A1633',
  'A1688',
  'A1700',
  'A1691',
  'N66AP',
  'iPhone8,2',
  'A1634',
  'A1687',
  'A1699',
  'A1690',
  'N69AP',
  'iPhone8,4',
  'A1662',
  'A1723',
  'A1724',
  'D10AP',
  'iPhone9,1',
  'A1660',
  'A1779',
  'A1780',
  'D101AP',
  'iPhone9,3',
  'A1778',
  'D11AP',
  'iPhone9,2',
  'A1661',
  'A1785',
  'A1786',
  'D111AP',
  'iPhone9,4',
  'A1784',
  'D20AP',
  'iPhone10,1',
  'A1863',
  'A1906',
  'A1907',
  'D201AP',
  'iPhone10,4',
  'A1905',
  'D21AP',
  'iPhone10,2',
  'A1864',
  'A1898',
  'A1899',
  'D211AP',
  'iPhone10,5',
  'A1897',
  'D22AP',
  'iPhone10,3',
  'A1865',
  'A1902',
  'A1903',
  'D221AP',
  'iPhone10,6',
  'A1901',
  'D321AP',
  'iPhone11,2',
  'A1920',
  'A2097',
  'A2098',
  'A2100',
  'A2099',
  'D331pAP',
  'iPhone11,6',
  'A1921',
  'A2101',
  'A2102',
  'A2104',
  'D331AP',
  'iPhone11,4',
  'A2103',
  'N841AP',
  'iPhone11,8',
  'A1984',
  'A2105',
  'A2106',
  'A2108',
  'A2107',
  'N104AP',
  'iPhone12,1',
  'A2111',
  'A2223',
  'A2222',
  'A2221',
  'D421AP',
  'iPhone12,3',
  'A2160',
  'A2217',
  'A2216',
  'A2215',
  'D431AP',
  'iPhone12,5',
  'A2161',
  'A2220',
  'A2219',
  'A2218',
  'D79AP',
  'iPhone12,8',
  'A2275',
  'A2298',
  'A2297',
  'A2296',
  'D52gAP',
  'iPhone13,1',
  'A2176',
  'A2398',
  'A2400',
  'A2399',
  'D53gAP',
  'iPhone13,2',
  'A2172',
  'A2402',
  'A2404',
  'A2403',
  'D53pAP',
  'iPhone13,3',
  'A2341',
  'A2406',
  'A2408',
  'A2407',
  'D54pAP',
  'iPhone13,4',
  'A2342',
  'A2410',
  'A2412',
  'A2411',
  'D16AP',
  'iPhone14,4',
  'A2481',
  'A2626',
  'A2629',
  'A2630',
  'A2628',
  'D17AP',
  'iPhone14,5',
  'A2482',
  'A2631',
  'A2634',
  'A2635',
  'A2633',
  'D63AP',
  'iPhone14,2',
  'A2483',
  'A2636',
  'A2639',
  'A2640',
  'A2638',
  'D64AP',
  'iPhone14,3',
  'A2484',
  'A2641',
  'A2644',
  'A2645',
  'A2643',
  'D49AP',
  'iPhone14,6',
  'A2595',
  'A2782',
  'A2784',
  'A2785',
  'A2783',
  'D27AP',
  'iPhone14,7',
  'A2649',
  'A2881',
  'A2883',
  'A2884',
  'A2882',
  'D28AP',
  'iPhone14,8',
  'A2632',
  'A2885',
  'A2887',
  'A2888',
  'A2886',
  'D73AP',
  'iPhone15,2',
  'A2650',
  'A2889',
  'A2891',
  'A2892',
  'A2890',
  'D74AP',
  'iPhone15,3',
  'A2651',
  'A2893',
  'A2895',
  'A2896',
  'A2894',
  'D37AP',
  'iPhone15,4',
  'A2846',
  'A3089',
  'A3092',
  'A3090',
  'D38AP',
  'iPhone15,5',
  'A2847',
  'A3093',
  'A3096',
  'A3094',
  'D83AP',
  'iPhone16,1',
  'A2848',
  'A3101',
  'A3104',
  'A3102',
  'D84AP',
  'iPhone16,2',
  'A2849',
  'A3105',
  'A3108',
  'A3106',
  'D47AP',
  'iPhone17,3',
  'A3081',
  'A3286',
  'A3288',
  'A3287',
  'D48AP',
  'iPhone17,4',
  'A3082',
  'A3289',
  'A3291',
  'A3290',
  'D93AP',
  'iPhone17,1',
  'A3083',
  'A3292',
  'A3294',
  'A3293',
  'D94AP',
  'iPhone17,2',
  'A3084',
  'A3295',
  'A3297',
  'A3296',
  'V59AP',
  'iPhone17,5',
  'A3212',
  'A3408',
  'A3410',
  'A3409',
  'V57AP',
  'iPhone18,3',
  'A3258',
  'A3519',
  'A3521',
  'A3520',
  'D23AP',
  'iPhone18,4',
  'A3260',
  'A3518',
  'A3516',
  'A3517',
  'V53AP',
  'iPhone18,1',
  'A3256',
  'A3522',
  'A3524',
  'A3523',
  'V54AP',
  'iPhone18,2',
  'A3257',
  'A3525',
  'A3527',
  'A3526',
  'K48AP',
  'iPad1,1',
  'A1219',
  'A1337',
  'K93AP',
  'iPad2,1',
  'A1395',
  'K94AP',
  'iPad2,2',
  'A1396',
  'K95AP',
  'iPad2,3',
  'A1397',
  'K93AAP',
  'iPad2,4',
  'A1395',
  'J1AP',
  'iPad3,1',
  'A1416',
  'J2AP',
  'iPad3,2',
  'A1403',
  'J2AAP',
  'iPad3,3',
  'A1430',
  'P101AP',
  'iPad3,4',
  'A1458',
  'P102AP',
  'iPad3,5',
  'A1459',
  'P103AP',
  'iPad3,6',
  'A1460',
  'J71sAP',
  'iPad6,11',
  'A1822',
  'J72sAP',
  'iPad6,12',
  'A1823',
  'J71bAP',
  'iPad7,5',
  'A1893',
  'J72bAP',
  'iPad7,6',
  'A1954',
  'J171AP',
  'iPad7,11',
  'A2197',
  'J172AP',
  'iPad7,12',
  'A2198',
  'A2200',
  'A2199',
  'J171aAP',
  'iPad11,6',
  'A2270',
  'J172aAP',
  'iPad11,7',
  'A2428',
  'A2429',
  'A2430',
  'J181AP',
  'iPad12,1',
  'A2602',
  'J182AP',
  'iPad12,2',
  'A2603',
  'A2604',
  'A2605',
  'J271AP',
  'iPad13,18',
  'A2696',
  'J272AP',
  'iPad13,19',
  'A2757',
  'A2777',
  'A3162',
  'J481AP',
  'iPad15,7',
  'A3354',
  'J482AP',
  'iPad15,8',
  'A3355',
  'A3356',
  'J71AP',
  'iPad4,1',
  'A1474',
  'J72AP',
  'iPad4,2',
  'A1475',
  'J73AP',
  'iPad4,3',
  'A1476',
  'J81AP',
  'iPad5,3',
  'A1566',
  'J82AP',
  'iPad5,4',
  'A1567',
  'J217AP',
  'iPad11,3',
  'A2152',
  'J218AP',
  'iPad11,4',
  'A2123',
  'A2153',
  'A2154',
  'J307AP',
  'iPad13,1',
  'A2316',
  'J308AP',
  'iPad13,2',
  'A2072',
  'A2324',
  'A2325',
  'J407AP',
  'iPad13,16',
  'A2588',
  'J408AP',
  'iPad13,17',
  'A2589',
  'A2591',
  'J507AP',
  'iPad14,8',
  'A2902',
  'J508AP',
  'iPad14,9',
  'A2903',
  'A2904',
  'J537AP',
  'iPad14,10',
  'A2898',
  'J538AP',
  'iPad14,11',
  'A2899',
  'A2900',
  'J607AP',
  'iPad15,3',
  'A3266',
  'J608AP',
  'iPad15,4',
  'A3267',
  'A3270',
  'J637AP',
  'iPad15,5',
  'A3268',
  'J638AP',
  'iPad15,6',
  'A3269',
  'A3271',
  'J98aAP',
  'iPad6,7',
  'A1584',
  'J99aAP',
  'iPad6,8',
  'A1652',
  'J127AP',
  'iPad6,3',
  'A1673',
  'J128AP',
  'iPad6,4',
  'A1674',
  'A1675',
  'J120AP',
  'iPad7,1',
  'A1670',
  'J121AP',
  'iPad7,2',
  'A1671',
  'A1821',
  'J207AP',
  'iPad7,3',
  'A1701',
  'J208AP',
  'iPad7,4',
  'A1709',
  'A1852',
  'J317AP',
  'iPad8,1',
  'A1980',
  'J317xAP',
  'iPad8,2',
  'A1980',
  'J318AP',
  'iPad8,3',
  'A1934',
  'A2013',
  'A1979',
  'J318xAP',
  'iPad8,4',
  'A1934',
  'A2013',
  'A1979',
  'J320AP',
  'iPad8,5',
  'A1876',
  'J320xAP',
  'iPad8,6',
  'A1876',
  'J321AP',
  'iPad8,7',
  'A1895',
  'A2014',
  'A1983',
  'J321xAP',
  'iPad8,8',
  'A1895',
  'A2014',
  'A1983',
  'J417AP',
  'iPad8,9',
  'A2228',
  'J418AP',
  'iPad8,10',
  'A2068',
  'A2230',
  'A2231',
  'J420AP',
  'iPad8,11',
  'A2229',
  'J421AP',
  'iPad8,12',
  'A2069',
  'A2232',
  'A2233',
  'J517AP',
  'iPad13,4',
  'A2377',
  'J517xAP',
  'iPad13,5',
  'A2377',
  'J518AP',
  'iPad13,6',
  'A2459',
  'A2301',
  'A2460',
  'J518xAP',
  'iPad13,7',
  'A2459',
  'A2301',
  'A2460',
  'J522AP',
  'iPad13,8',
  'A2378',
  'J522xAP',
  'iPad13,9',
  'A2378',
  'J523AP',
  'iPad13,10',
  'A2461',
  'A2379',
  'A2462',
  'J523xAP',
  'iPad13,11',
  'A2461',
  'A2379',
  'A2462',
  'J617AP',
  'iPad14,3',
  'A2759',
  'J618AP',
  'iPad14,4',
  'A2761',
  'A2435',
  'A2762',
  'J620AP',
  'iPad14,5',
  'A2436',
  'J621AP',
  'iPad14,6',
  'A2437',
  'A2764',
  'A2766',
  'J717AP',
  'iPad16,3',
  'A2836',
  'J718AP',
  'iPad16,4',
  'A2837',
  'A3006',
  'J720AP',
  'iPad16,5',
  'A2925',
  'J721AP',
  'iPad16,6',
  'A2926',
  'A3007',
  'J817AP',
  'iPad17,1',
  'A3357',
  'J818AP',
  'iPad17,2',
  'A3358',
  'A3359',
  'J820AP',
  'iPad18,1',
  'A3360',
  'J821AP',
  'iPad18,2',
  'A3361',
  'A3362',
  'P105AP',
  'iPad2,5',
  'A1432',
  'P106AP',
  'iPad2,6',
  'A1454',
  'P107AP',
  'iPad2,7',
  'A1455',
  'J85AP',
  'iPad4,4',
  'A1489',
  'J86AP',
  'iPad4,5',
  'A1490',
  'J87AP',
  'iPad4,6',
  'A1491',
  'J85mAP',
  'iPad4,7',
  'A1599',
  'J86mAP',
  'iPad4,8',
  'A1600',
  'J87mAP',
  'iPad4,9',
  'A1601',
  'J96AP',
  'iPad5,1',
  'A1538',
  'J97AP',
  'iPad5,2',
  'A1550',
  'J210AP',
  'iPad11,1',
  'A2133',
  'J211AP',
  'iPad11,2',
  'A2124',
  'A2126',
  'A2125',
  'J310AP',
  'iPad14,1',
  'A2567',
  'J311AP',
  'iPad14,2',
  'A2568',
  'A2569',
  'J410AP',
  'iPad16,1',
  'A2993',
  'J411AP',
  'iPad16,2',
  'A2995',
  'A2996',
  'N27aAP',
  'Watch1,1',
  'A1553',
  'N28aAP',
  'Watch1,2',
  'A1554',
  'N27dAP',
  'Watch2,6',
  'A1802',
  'N28dAP',
  'Watch2,7',
  'A1803',
  'N74AP',
  'Watch2,3',
  'A1757',
  'A1816',
  'N75AP',
  'Watch2,4',
  'A1758',
  'A1817',
  'N111sAP',
  'Watch3,1',
  'A1860',
  'A1889',
  'A1890',
  'N111bAP',
  'Watch3,2',
  'A1861',
  'A1891',
  'A1892',
  'N121sAP',
  'Watch3,3',
  'A1858',
  'N121bAP',
  'Watch3,4',
  'A1859',
  'N131sAP',
  'Watch4,1',
  'A1977',
  'N131bAP',
  'Watch4,2',
  'A1978',
  'N141sAP',
  'Watch4,3',
  'A1975',
  'A2007',
  'N141bAP',
  'Watch4,4',
  'A1976',
  'A2008',
  'N144sAP',
  'Watch5,1',
  'A2092',
  'N144bAP',
  'Watch5,2',
  'A2093',
  'N146sAP',
  'Watch5,3',
  'A2094',
  'A2156',
  'N146bAP',
  'Watch5,4',
  'A2095',
  'A2157',
  'N157sAP',
  'Watch6,1',
  'A2291',
  'N157bAP',
  'Watch6,2',
  'A2292',
  'N158sAP',
  'Watch6,3',
  'A2293',
  'A2375',
  'N158bAP',
  'Watch6,4',
  'A2294',
  'A2376',
  'N187sAP',
  'Watch6,6',
  'A2473',
  'N187bAP',
  'Watch6,7',
  'A2474',
  'N188sAP',
  'Watch6,8',
  'A2475',
  'A2476',
  'N188bAP',
  'Watch6,9',
  'A2477',
  'A2478',
  'N197sAP',
  'Watch6,14',
  'A2770',
  'N197bAP',
  'Watch6,15',
  'A2771',
  'N198sAP',
  'Watch6,16',
  'A2772',
  'A2857',
  'A2773',
  'N198bAP',
  'Watch6,17',
  'A2774',
  'A2858',
  'A2775',
  'N207sAP',
  'Watch7,1',
  'A2978',
  'N207bAP',
  'Watch7,2',
  'A2980',
  'N208sAP',
  'Watch7,3',
  'A2982',
  'A2983',
  'N208bAP',
  'Watch7,4',
  'A2984',
  'A2985',
  'N217sAP',
  'Watch7,8',
  'A2997',
  'A2998',
  'N217bAP',
  'Watch7,9',
  'A2999',
  'A3000',
  'N218sAP',
  'Watch7,10',
  'A3001',
  'A3002',
  'N218bAP',
  'Watch7,11',
  'A3003',
  'A3206',
  'N227sAP',
  'Watch7,17',
  'A3331',
  'A3450',
  'N227bAP',
  'Watch7,18',
  'A3333',
  'A3451',
  'N228sAP',
  'Watch7,19',
  'A3335',
  'A3452',
  'N228bAP',
  'Watch7,20',
  'A3337',
  'A3453',
  'N140sAP',
  'Watch5,9',
  'A2351',
  'N140bAP',
  'Watch5,10',
  'A2352',
  'N142sAP',
  'Watch5,11',
  'A2353',
  'A2355',
  'N142bAP',
  'Watch5,12',
  'A2354',
  'A2356',
  'N143sAP',
  'Watch6,10',
  'A2722',
  'N143bAP',
  'Watch6,11',
  'A2723',
  'N149sAP',
  'Watch6,12',
  'A2726',
  'A2855',
  'A2725',
  'N149bAP',
  'Watch6,13',
  'A2727',
  'A2856',
  'A2724',
  'N243sAP',
  'Watch7,13',
  'A3324',
  'A3391',
  'N243bAP',
  'Watch7,14',
  'A3325',
  'A3392',
  'N244sAP',
  'Watch7,15',
  'A3326',
  'A3327',
  'N244bAP',
  'Watch7,16',
  'A3328',
  'A3329',
  'N199AP',
  'Watch6,18',
  'A2622',
  'A2859',
  'A2684',
  'N210AP',
  'Watch7,5',
  'A2986',
  'A2987',
  'A2986',
  'N230AP',
  'Watch7,12',
  'A3281',
  'A3282',
  'AppleTV1,1',
  'A1218',
  'K66AP',
  'AppleTV2,1',
  'A1378',
  'J33AP',
  'AppleTV3,1',
  'A1427',
  'J33IAP',
  'AppleTV3,2',
  'A1469',
  'J42dAP',
  'AppleTV5,3',
  'A1625',
  'J105aAP',
  'AppleTV6,2',
  'A1842',
  'J305AP',
  'AppleTV11,1',
  'A2169',
  'J255AP',
  'AppleTV14,1',
  'A2737',
  'A2843',
  'N301AP',
  'RealityDevice14,1',
  'A2117',
  'N301aAP',
  'RealityDevice17,1,1',
  'A3416',
  'N45AP',
  'iPod1,1',
  'A1213',
  'N72AP',
  'iPod2,1',
  'A1288',
  'A1319',
  'N18AP',
  'iPod3,1',
  'A1318',
  'N81AP',
  'iPod4,1',
  'A1367',
  'N78AP',
  'iPod5,1',
  'A1421',
  'A1509',
  'N102AP',
  'iPod7,1',
  'A1574',
  'N112AP',
  'iPod9,1',
  'A2178',
]